import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.agent');
import { OnInit, OnDestroy, Input, ViewChild, ElementRef, ChangeDetectorRef, HostListener } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { Subscription } from 'rxjs';

declare const WizRoute: any;

// Showdown (Markdown 렌더링)
import showdown from 'showdown';

const APP_ID = 'page.agent';

// Markdown converter 설정
const mdConverter = new showdown.Converter({
    tables: true,
    ghCodeBlocks: true,
    tasklists: true,
    strikethrough: true,
    simplifiedAutoLink: true,
    openLinksInNewWindow: true,
});

// ── Block 기반 메시지 구조 (oedix v2) ──

interface TextBlock {
    type: 'text';
    action_id?: string;
    content: string;
}

interface ToolBlock {
    type: 'tool';
    action_id?: string;
    id: string;
    name: string;
    summary: string;
    input: any;
    status: 'pending' | 'running' | 'complete' | 'error';
    result?: string;
    collapsed: boolean;
    canvasData?: any;
    canvasTool?: string;
    canvasInfo?: any;
    outputFiles?: OutputFile[];
}

interface OutputFile {
    path: string;
    filename: string;
    mime_type?: string;
    size?: number;
    source: 'endpoint' | 'storage';
    is_image?: boolean;
}

interface PlannedAction {
    id: string;
    type: string;
    purpose: string;
    status: 'pending' | 'running' | 'completed' | 'failed';
    error?: string;
}

interface ThinkingBlock {
    type: 'thinking';
    action_id?: string;
    content: string;
    collapsed: boolean;
    status?: 'streaming' | 'complete';
    decision?: string;
    analysis?: string;
    reasoning?: string;
    action_count?: number;
    planned_actions?: PlannedAction[];
}

interface PlanBlock {
    type: 'plan';
    action_id?: string;
    action_sets: string[];
    mode: string;
    analysis: string;
    collapsed: boolean;
}

interface ActionSetBlock {
    type: 'action_set';
    action_id?: string;
    set_id?: string;
    subject: string;
    title?: string;
    status: 'running' | 'completed' | 'failed';
    actions_completed?: number;
    collapsed: boolean;
}

interface ThinkingUnit {
    type: 'thinking_unit';
    index: number;
    blocks: MessageBlock[];
    collapsed: boolean;
}

interface ActionSetGroup {
    type: 'action_set_group';
    actionSet: ActionSetBlock;
    units: ThinkingUnit[];
}

type RenderItem = MessageBlock | ActionSetGroup;

interface ContextSummaryBlock {
    type: 'context_summary';
    action_id?: string;
    phase: string;
    mode: string;
    detail: string;
    collapsed: boolean;
}

type MessageBlock = TextBlock | ToolBlock | ThinkingBlock | PlanBlock | ActionSetBlock | ContextSummaryBlock;

interface ChatMessage {
    role: 'user' | 'assistant';
    content: string;
    blocks: MessageBlock[];
    outputFiles?: OutputFile[];
    canvasRef?: { tool: string; label: string; source: string; block?: ToolBlock };
}

@Component({
    selector: 'wiz-page-agent',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.agent/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.mobile-menu-btn {
  display: none;
}

.mobile-overlay {
  display: none;
}

@media (max-width: 767px) {
  .mobile-menu-btn {
    display: flex;
  }
  .activity-bar {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 50;
    height: 100%;
    box-shadow: 4px 0 16px rgba(0, 0, 0, 0.3);
  }
  .activity-bar.mobile-open {
    display: flex;
  }
  .mobile-overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 40;
    background: rgba(0, 0, 0, 0.4);
  }
  .panel-area {
    width: 100% !important;
  }
  .resize-divider {
    display: none;
  }
  .chat-area.panel-active {
    display: none;
  }
}
.activity-bar button[data-tooltip]::before, .activity-bar button[data-tooltip]::after {
  position: absolute;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.15s ease, visibility 0.15s ease;
  z-index: 1000;
}
.activity-bar button[data-tooltip]::after {
  content: attr(data-tooltip);
  left: calc(100% + 10px);
  top: 50%;
  transform: translateY(-50%);
  white-space: nowrap;
  padding: 5px 10px;
  border-radius: 6px;
  background: #18181b;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}
.activity-bar button[data-tooltip]::before {
  content: "";
  left: calc(100% + 5px);
  top: 50%;
  transform: translateY(-50%);
  border: 5px solid transparent;
  border-right-color: #18181b;
}
.activity-bar button[data-tooltip]:hover::before, .activity-bar button[data-tooltip]:hover::after {
  opacity: 1;
  visibility: visible;
}

.storage-drag-over {
  background: rgba(59, 130, 246, 0.03);
}

.prose pre {
  background: #1e1e1e;
  color: #d4d4d4;
  border-radius: 8px;
  padding: 14px 16px;
  overflow-x: auto;
  font-size: 12px;
  line-height: 1.6;
  margin: 8px 0;
}
.prose pre code {
  background: transparent;
  padding: 0;
  color: inherit;
}
.prose code {
  background: #f3f4f6;
  color: #374151;
  padding: 2px 5px;
  border-radius: 4px;
  font-size: 12px;
}
.prose p {
  margin: 0.5em 0;
  line-height: 1.7;
}
.prose ul, .prose ol {
  margin: 0.5em 0;
  padding-left: 1.5em;
}
.prose li {
  margin: 0.25em 0;
}
.prose table {
  font-size: 13px;
  border-collapse: collapse;
  width: 100%;
  margin: 8px 0;
}
.prose table th, .prose table td {
  border: 1px solid #e5e7eb;
  padding: 6px 10px;
}
.prose table th {
  background: #f9fafb;
  font-weight: 500;
}
.prose h1, .prose h2, .prose h3, .prose h4 {
  margin-top: 1em;
  margin-bottom: 0.25em;
  font-weight: 600;
  color: #111827;
}
.prose blockquote {
  border-left: 3px solid #e5e7eb;
  padding-left: 12px;
  margin: 8px 0;
  color: #6b7280;
}
.prose a {
  color: #2563eb;
  text-decoration: none;
}
.prose a:hover {
  text-decoration: underline;
}
.prose hr {
  border: none;
  border-top: 1px solid #f3f4f6;
  margin: 16px 0;
}

pre {
  margin: 0;
  word-break: break-all;
}

textarea {
  min-height: 40px;
  max-height: 160px;
}

@keyframes bounce-dot {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-4px);
  }
}
.action-set-group .action-set-steps .step-header:last-child {
  border-bottom: none;
}
.action-set-group .action-set-steps .step-content .step-blocks > ng-container > div:last-child {
  margin-bottom: 4px;
}
.action-set-group .step-number {
  font-size: 11px;
  line-height: 1;
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}`],
})
export class PageAgentComponent implements OnInit, OnDestroy {
    @Input() title: any;
    @ViewChild('chatContainer') chatContainer: ElementRef;
    @ViewChild('chatInputRef') chatInputRef: ElementRef;
    @ViewChild('canvasIframe') canvasIframe: ElementRef;

    private routerSub: Subscription | null = null;

    // ── Chat 상태 ──
    public chatMessages: ChatMessage[] = [];
    public chatHistory: any[] = [];
    public chatInput: string = '';
    public chatLoading: boolean = false;
    public currentSessionId: string = '';

    // Settings 패널 (agent.json)
    public settingsJson: string = '';
    public settingsConfig: any = {};
    public settingsLoading: boolean = false;
    public settingsSaving: boolean = false;
    public settingsAdvancedMode: boolean = false;
    public settingsProviderList: string[] = [];
    public settingsProviderModelsMap: { [provider: string]: any[] } = {};

    // Harness 설정 패널 (data_root/harness/config.json)
    public harnessJson: string = '';
    public harnessConfig: any = {};
    public harnessLoading: boolean = false;
    public harnessSaving: boolean = false;
    public harnessAdvancedMode: boolean = false;
    public harnessPathInfo: any = {};

    // 모델 선택
    public providers: any[] = [];
    public selectedProvider: string = '';
    public selectedModel: string = '';
    public currentModels: any[] = [];

    // Context 통계
    public contextStats: any = null;
    public contextStatsPopup: boolean = false;

    // Activity Bar + Panel 시스템
    public activePanel: string | null = null;
    public panelWidth: number = 33;
    public isResizing: boolean = false;
    public mobileMenuOpen: boolean = false;
    public activityBarItems = [
        { id: 'storage', icon: 'storage', label: '스토리지', tooltip: '스토리지' },
        { id: 'canvas', icon: 'canvas', label: 'Canvas', tooltip: 'Canvas 결과' },
    ];

    // Canvas 패널
    public activeCanvas: ToolBlock | null = null;
    public canvasHistory: ToolBlock[] = [];
    public canvasHistoryDropdownOpen: boolean = false;
    public canvasRefEnabled: boolean = true;
    private canvasUrls: { [toolName: string]: SafeResourceUrl } = {};
    private _pendingCanvasUpdates: { canvas_id: string; updates: any[] }[] = [];

    // Storage 상태 (User only)
    public storagePath: string = '/';
    public storageBreadcrumb: { name: string; path: string }[] = [];
    public storageFiles: any[] = [];
    public storageLoading: boolean = false;
    public isDraggingOver: boolean = false;
    public uploadProgress: { name: string; percent: number }[] = [];

    // 파일 뷰어/에디터 상태
    public storageFileViewer: {
        open: boolean;
        loading: boolean;
        saving: boolean;
        filename: string;
        path: string;
        content: string;
        originalContent: string;
        isImage: boolean;
        isBinary: boolean;
        mimeType: string;
        size: number;
        modified: boolean;
    } = {
        open: false, loading: false, saving: false,
        filename: '', path: '', content: '', originalContent: '',
        isImage: false, isBinary: false, mimeType: '', size: 0, modified: false,
    };

    // 드래그 앤 드롭 파일 이동 상태
    public storageDragItem: any = null;
    public storageDragOverFolder: string | null = null;

    // 컨텍스트 메뉴
    public contextMenu: { visible: boolean; x: number; y: number; item: any } = { visible: false, x: 0, y: 0, item: null };
    public storageFileTools: any[] = [];
    public storageToolsLoading: boolean = false;

    // Canvas 컨텍스트 (iframe에서 수집)
    public canvasContext: any = null;

    @ViewChild('storageFileInput') storageFileInput: ElementRef;

    // History 패널
    public historyList: any[] = [];
    public historyLoading: boolean = false;

    // Tools 패널
    public toolsList: any[] = [];
    public toolsLoading: boolean = false;
    public expandedTools: Set<string> = new Set();
    public disabledTools: string[] = [];
    public toolDetail: any = null;
    public toolDetailMode: boolean = false;
    public toolTestInput: string = '{}';
    public toolTestResult: string = '';
    public toolTestRunning: boolean = false;
    public toolSearchQuery: string = '';

    // Actions 패널
    public actionsList: any[] = [];
    public actionsLoading: boolean = false;
    public actionDetail: any = null;
    public actionDetailMode: boolean = false;
    public actionSearchQuery: string = '';
    public expandedActions: Set<string> = new Set();

    // 인라인 입력 모달 (prompt 대체)
    public promptModal: { visible: boolean; title: string; value: string; placeholder: string; resolve: ((val: string | null) => void) | null } = { visible: false, title: '', value: '', placeholder: '', resolve: null };

    // 자동 스크롤
    public isUserScrolledUp: boolean = false;

    // Plan 상단 고정
    public activePlan: { subject: string; status: string }[] = [];
    public planExpanded: boolean = false;

    // IME 조합 상태
    public isComposing: boolean = false;

    // 동적 로딩 상태
    public hasMoreMessages: boolean = false;
    public oldestMessageId: number | null = null;
    public loadingOlderMessages: boolean = false;
    public totalMessageCount: number = 0;
    private readonly MESSAGES_PER_PAGE: number = 20;

    private chatAbortController: AbortController | null = null;
    private chatAssistantIdx: number = -1;

    constructor(@Inject( Service)         public service: Service,@Inject( ChangeDetectorRef)         private cdr: ChangeDetectorRef,@Inject( DomSanitizer)         private sanitizer: DomSanitizer,@Inject( Router)         private router: Router,    ) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadProviders();
        this.setupCanvasListener();

        // URL에서 세션 ID 확인
        const urlSessionId = WizRoute.segment?.session_id;
        if (urlSessionId) {
            this.currentSessionId = urlSessionId;
            await this.loadSessionFromId(urlSessionId);
        } else {
            this.generateSessionId();
        }

        // 라우팅 변경 감지 (같은 컴포넌트 재사용 대응)
        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const newSessionId = WizRoute.segment?.session_id;
                if (newSessionId && newSessionId !== this.currentSessionId) {
                    this.currentSessionId = newSessionId;
                    await this.loadSessionFromId(newSessionId);
                }
            }
        });

        await this.service.render();
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    // =========================================================================
    // Session Management
    // =========================================================================

    private generateSessionId() {
        const now = new Date();
        const pad = (n: number) => n.toString().padStart(2, '0');
        this.currentSessionId = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
    }

    public startNewSession() {
        this.chatMessages = [];
        this.chatHistory = [];
        this.chatAssistantIdx = -1;
        this.activeCanvas = null;
        this.activePlan = [];
        this.planExpanded = false;
        this.contextStats = null;
        this.contextStatsPopup = false;
        this.hasMoreMessages = false;
        this.oldestMessageId = null;
        this.totalMessageCount = 0;
        this.generateSessionId();
        if (this.activePanel === 'canvas') {
            this.activePanel = null;
        }
        this.updateUrlSessionId();
        this.cdr.detectChanges();
    }

    private updateUrlSessionId() {
        this.service.href(`/agent/${this.currentSessionId}`);
    }

    private async loadSessionFromId(sessionId: string) {
        try {
            // 최근 N건만 먼저 로드
            const res = await wiz.call('conversation_load', {
                session_id: sessionId,
                limit: String(this.MESSAGES_PER_PAGE),
            });
            const data = res.data?.session;
            if (data && data.messages && data.messages.length > 0) {
                this.restoreSessionData(data);
            }
        } catch (e) {
            // 세션이 없으면 새 세션으로 시작
        }
    }

    public async loadOlderMessages() {
        if (this.loadingOlderMessages || !this.hasMoreMessages || !this.oldestMessageId) return;
        this.loadingOlderMessages = true;
        this.cdr.detectChanges();

        try {
            const res = await wiz.call('conversation_load', {
                session_id: this.currentSessionId,
                before_id: String(this.oldestMessageId),
                limit: String(this.MESSAGES_PER_PAGE),
            });
            const data = res.data?.session;
            if (data && data.messages && data.messages.length > 0) {
                const olderMessages: ChatMessage[] = [];
                for (const m of data.messages) {
                    const blocks = this.deserializeBlocks(m.blocks, m.content);
                    const chatMsg: ChatMessage = { role: m.role, content: m.content || '', blocks };
                    if (m.role === 'assistant') this._collectOutputFiles(chatMsg);
                    olderMessages.push(chatMsg);
                }

                // 스크롤 위치 보존
                const container = this.chatContainer?.nativeElement;
                const prevScrollHeight = container ? container.scrollHeight : 0;

                // 앞쪽에 삽입
                this.chatMessages = [...olderMessages, ...this.chatMessages];

                // chatHistory도 앞쪽에 삽입
                const olderHistory = data.messages.map((m: any) => ({ role: m.role, content: m.content || '' }));
                this.chatHistory = [...olderHistory, ...this.chatHistory];

                // oldest ID 갱신
                if (data.messages.length > 0) {
                    this.oldestMessageId = data.messages[0].id;
                }
                this.hasMoreMessages = data.has_more || false;

                this.cdr.detectChanges();

                // 스크롤 위치 복원
                if (container) {
                    const newScrollHeight = container.scrollHeight;
                    container.scrollTop = newScrollHeight - prevScrollHeight;
                }
            } else {
                this.hasMoreMessages = false;
            }
        } catch (e) {
            console.error('Load older messages error:', e);
        } finally {
            this.loadingOlderMessages = false;
            this.cdr.detectChanges();
        }
    }

    private restoreSessionData(data: any) {
        const messages = data.messages || [];
        this.chatMessages = [];
        this.chatHistory = [];
        for (const m of messages) {
            const blocks = this.deserializeBlocks(m.blocks, m.content);
            const chatMsg: ChatMessage = { role: m.role, content: m.content || '', blocks };
            if (m.role === 'assistant') this._collectOutputFiles(chatMsg);
            this.chatMessages.push(chatMsg);
            this.chatHistory.push({ role: m.role, content: m.content || '' });
        }
        this.chatAssistantIdx = -1;
        this.activeCanvas = null;
        this.activePlan = [];
        this.planExpanded = false;
        if (this.activePanel === 'canvas') this.activePanel = null;

        // 동적 로딩 상태 초기화
        this.totalMessageCount = data.total_count || messages.length;
        this.hasMoreMessages = data.has_more || false;
        if (messages.length > 0 && messages[0].id) {
            this.oldestMessageId = messages[0].id;
        } else {
            this.oldestMessageId = null;
        }

        this.cdr.detectChanges();
    }

    private deserializeBlocks(blocks: any[], fallbackContent: string): MessageBlock[] {
        if (!blocks || blocks.length === 0) {
            return fallbackContent ? [{ type: 'text', content: fallbackContent }] : [];
        }
        return blocks.map((b: any) => {
            const aid = b.action_id || undefined;
            switch (b.type) {
                case 'text':
                    return { type: 'text', action_id: aid, content: b.content || '' } as TextBlock;
                case 'tool':
                    return { type: 'tool', action_id: aid, id: b.id || '', name: b.name || '', summary: b.summary || '', input: b.input || {}, status: b.status || 'complete', result: b.result || '', collapsed: true, canvasData: b.canvasData || null, canvasTool: b.canvasTool || null, canvasInfo: b.canvasInfo || null, outputFiles: b.outputFiles || undefined } as ToolBlock;
                case 'thinking':
                    return { type: 'thinking', action_id: aid, content: b.content || '', collapsed: true, status: 'complete', decision: b.decision || '', analysis: b.analysis || '', reasoning: b.reasoning || '', action_count: b.action_count || 0, planned_actions: b.planned_actions || undefined } as ThinkingBlock;
                case 'decision':
                    // Legacy: convert old decision blocks to thinking blocks
                    return { type: 'thinking', action_id: aid, content: '', collapsed: true, status: 'complete', decision: b.decision || '', analysis: b.analysis || '', reasoning: b.reasoning || '', action_count: b.action_count || 0, planned_actions: b.planned_actions || undefined } as ThinkingBlock;
                case 'plan':
                    return { type: 'plan', action_id: aid, action_sets: b.action_sets || b.steps || [], mode: b.mode || '', analysis: b.analysis || '', collapsed: true } as PlanBlock;
                case 'action_set':
                    return { type: 'action_set', action_id: aid, set_id: b.set_id || '', subject: b.subject || '', title: b.title || '', status: b.status || 'completed', actions_completed: b.actions_completed || 0, collapsed: true } as ActionSetBlock;
                case 'context_summary':
                    return { type: 'context_summary', action_id: aid, phase: b.phase || '', mode: b.mode || '', detail: b.detail || b.summary || '', collapsed: true } as ContextSummaryBlock;
                default:
                    return { type: 'text', action_id: aid, content: b.content || '' } as TextBlock;
            }
        });
    }

    // =========================================================================
    // Modal Helpers (시스템 다이얼로그 대체)
    // =========================================================================

    public showPrompt(title: string, placeholder: string = '', defaultValue: string = ''): Promise<string | null> {
        return new Promise((resolve) => {
            this.promptModal = { visible: true, title, value: defaultValue, placeholder, resolve };
            this.cdr.detectChanges();
        });
    }

    public promptConfirm() {
        if (this.promptModal.resolve) this.promptModal.resolve(this.promptModal.value);
        this.promptModal = { visible: false, title: '', value: '', placeholder: '', resolve: null };
        this.cdr.detectChanges();
    }

    public promptCancel() {
        if (this.promptModal.resolve) this.promptModal.resolve(null);
        this.promptModal = { visible: false, title: '', value: '', placeholder: '', resolve: null };
        this.cdr.detectChanges();
    }

    public async showConfirm(message: string): Promise<boolean> {
        const res = await this.service.modal.show({
            title: '확인',
            message: message,
            action: '확인',
            actionBtn: 'warning',
            cancel: '취소',
            status: 'warning'
        });
        return res !== false && res !== undefined;
    }

    // =========================================================================
    // Chat Core
    // =========================================================================

    public async sendChat() {
        const message = this.chatInput.trim();
        if (!message || this.chatLoading) return;

        // 1. UI 상태 업데이트
        const userMsg: ChatMessage = { role: 'user', content: message, blocks: [] };
        if (this.canvasRefEnabled && this.activeCanvas) {
            userMsg.canvasRef = {
                tool: this.activeCanvas.canvasTool || this.activeCanvas.name || '',
                label: this.getCanvasLabel(this.activeCanvas),
                source: this.getCanvasSource(this.activeCanvas),
                block: { ...this.activeCanvas },
            };
        }
        this.chatMessages.push(userMsg);
        this.chatInput = '';

        // textarea 강제 초기화 (IME 잔류 방지)
        if (this.chatInputRef?.nativeElement) {
            this.chatInputRef.nativeElement.value = '';
        }

        this.chatLoading = true;
        this.isUserScrolledUp = false;
        this.chatAbortController = new AbortController();

        // 2. 빈 assistant 메시지 (스트리밍으로 블록 누적)
        const assistantMsg: ChatMessage = {
            role: 'assistant',
            content: '',
            blocks: [],
        };
        this.chatMessages.push(assistantMsg);
        this.chatAssistantIdx = this.chatMessages.length - 1;

        // 3. Canvas 컨텍스트 수집 (활성 Canvas가 있고 참조 활성화 시 요청)
        let canvasContextData: any = null;
        if (this.canvasRefEnabled && this.activeCanvas && this.canvasIframe?.nativeElement) {
            try {
                canvasContextData = await this.requestCanvasContext();
            } catch (e) {
                // 컨텍스트 수집 실패 시 무시
            }
        }
        // 기존 저장된 컨텍스트도 활용
        if (this.canvasRefEnabled && !canvasContextData && this.canvasContext) {
            canvasContextData = this.canvasContext;
        }

        // 4. form-urlencoded body
        const params = new URLSearchParams();
        params.append('session_id', this.currentSessionId);
        params.append('message', message);
        params.append('history', JSON.stringify(this.chatHistory));
        if (this.selectedProvider) params.append('provider', this.selectedProvider);
        if (this.selectedModel) params.append('model', this.selectedModel);
        if (canvasContextData) {
            params.append('canvas_context', JSON.stringify(canvasContextData));
        }

        try {
            // 5. fetch + SSE
            const response = await fetch(
                `/wiz/api/${APP_ID}/agent_chat`,
                {
                    method: 'POST',
                    body: params,
                    signal: this.chatAbortController.signal
                }
            );

            // 5. ReadableStream 처리
            const reader = response.body!.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n\n');
                buffer = lines.pop() || '';

                for (const line of lines) {
                    if (line.startsWith('data: ')) {
                        try {
                            const event = JSON.parse(line.slice(6));
                            this.handleChatEvent(event);
                        } catch (e) {
                            console.error('SSE parse error:', e);
                        }
                    }
                }
            }
        } catch (e: any) {
            if (e.name !== 'AbortError') {
                const msg = this.chatMessages[this.chatAssistantIdx];
                this._appendTextToBlocks(msg, `\n\n**Error:** ${e.message}`);
            }
        } finally {
            this.chatLoading = false;
            this.chatAbortController = null;
            this.scrollToBottom();
            await this.service.render();
        }
    }

    private handleChatEvent(event: any) {
        const msg = this.chatMessages[this.chatAssistantIdx];
        const actionId = event.action_id || undefined;
        const d = event.data || {};

        switch (event.type) {
            // ── ResponseAction: 최종 응답 스트리밍 ──
            case 'response': {
                const blocks = msg.blocks;
                const last = blocks.length > 0 ? blocks[blocks.length - 1] : null;
                let textBlock: TextBlock;
                if (last && last.type === 'text' && (last as any).action_id === actionId) {
                    textBlock = last as TextBlock;
                } else {
                    textBlock = { type: 'text', action_id: actionId, content: '' } as TextBlock;
                    blocks.push(textBlock);
                }
                textBlock.content += (d.content || '');
                this.scrollToBottom();
                break;
            }

            // ── ThinkingAction: 사고 과정 스트리밍 ──
            case 'thinking': {
                if (d.phase === 'start') {
                    msg.blocks.push({
                        type: 'thinking', action_id: actionId, content: '', collapsed: true,
                        status: 'streaming',
                    } as ThinkingBlock);
                } else if (d.phase === 'streaming') {
                    const blocks = msg.blocks;
                    const last = blocks.length > 0 ? blocks[blocks.length - 1] : null;
                    let thinkBlock: ThinkingBlock;
                    if (last && last.type === 'thinking' && (last as any).action_id === actionId) {
                        thinkBlock = last as ThinkingBlock;
                    } else {
                        thinkBlock = { type: 'thinking', action_id: actionId, content: '', collapsed: true, status: 'streaming' } as ThinkingBlock;
                        blocks.push(thinkBlock);
                    }
                    thinkBlock.content += (d.chunk || '');
                }
                // phase 'error' → 무시 (ERROR 이벤트로 별도 처리됨)
                this.scrollToBottom();
                break;
            }

            // ── ThinkingAction: 의사결정 결과 (ThinkingBlock에 병합) ──
            case 'decision': {
                const thinkBlock = [...msg.blocks].reverse().find(
                    b => b.type === 'thinking' && (b as any).action_id === actionId
                ) as ThinkingBlock | undefined;
                if (thinkBlock) {
                    thinkBlock.status = 'complete';
                    thinkBlock.decision = d.decision || '';
                    thinkBlock.analysis = d.analysis || '';
                    thinkBlock.reasoning = d.reasoning || '';
                    thinkBlock.action_count = d.action_count || 0;
                }
                this.scrollToBottom();
                break;
            }

            // ── ThinkingAction: 접근 방식 변경 ──
            case 'approach_update':
                // 경량 이벤트 — 별도 블록 불필요
                break;

            // ── ThinkingAction: 예정 액션 목록 ──
            case 'action_plan': {
                const thinkBlock = [...msg.blocks].reverse().find(
                    b => b.type === 'thinking' && (b as any).action_id === actionId
                ) as ThinkingBlock | undefined;
                if (thinkBlock) {
                    thinkBlock.planned_actions = (d.actions || []).map((a: any) => ({
                        id: a.id,
                        type: a.type,
                        purpose: a.purpose || '',
                        status: 'pending' as const,
                    }));
                }
                this.scrollToBottom();
                break;
            }

            // ── ActionSet: 개별 액션 시작 ──
            case 'action_start': {
                const targetActionId = d.action_id;
                if (targetActionId) {
                    for (const block of msg.blocks) {
                        if (block.type === 'thinking' && (block as ThinkingBlock).planned_actions) {
                            const pa = (block as ThinkingBlock).planned_actions!.find(a => a.id === targetActionId);
                            if (pa) {
                                pa.status = 'running';
                                break;
                            }
                        }
                    }
                }
                break;
            }

            // ── ActionSet: 개별 액션 완료 ──
            case 'action_complete': {
                const doneActionId = d.action_id;
                if (doneActionId) {
                    for (const block of msg.blocks) {
                        if (block.type === 'thinking' && (block as ThinkingBlock).planned_actions) {
                            const pa = (block as ThinkingBlock).planned_actions!.find(a => a.id === doneActionId);
                            if (pa) {
                                pa.status = d.status === 'failed' ? 'failed' : 'completed';
                                if (d.error) pa.error = d.error;
                                break;
                            }
                        }
                    }
                }
                if (d.context_stats) this.contextStats = d.context_stats;
                break;
            }

            // ── ToolAction: 도구 실행 시작 ──
            case 'tool_use':
                msg.blocks.push({
                    type: 'tool',
                    action_id: actionId,
                    id: d.id || actionId || '',
                    name: d.name || '',
                    summary: this._generateToolSummary(d.name, d.input),
                    input: d.input || {},
                    status: 'pending',
                    collapsed: false,
                });
                this.scrollToBottom();
                break;

            // ── ToolAction: 도구 실행 결과 ──
            case 'tool_result': {
                let canvasData: any = null;
                let canvasTool: string | null = null;
                let canvasInfo: any = null;
                let outputFiles: OutputFile[] | null = null;
                let displayResult = d.result;

                // output_files가 이벤트 최상위에 있으면 우선 사용
                if (d.output_files && Array.isArray(d.output_files) && d.output_files.length > 0) {
                    outputFiles = d.output_files;
                }

                // canvas_data가 이벤트 최상위에 있으면 우선 사용 (truncation 방지)
                if (d.canvas_data) {
                    canvasData = d.canvas_data;
                    canvasTool = d.name;
                    canvasInfo = d.canvas_info || null;
                }

                try {
                    const parsed = JSON.parse(d.result);
                    // fallback: result JSON 내 canvas 데이터
                    if (!canvasData && parsed.canvas && parsed.data) {
                        canvasData = parsed.data;
                        canvasTool = d.name;
                        if (typeof parsed.canvas === 'object') {
                            canvasInfo = parsed.canvas;
                        }
                    }
                    if (canvasData) {
                        displayResult = parsed.text || d.result;
                    }
                    // fallback: result JSON 내 output_files
                    if (!outputFiles && parsed.output_files && Array.isArray(parsed.output_files) && parsed.output_files.length > 0) {
                        outputFiles = parsed.output_files;
                    }
                } catch (e) {
                    // 일반 텍스트 결과
                }

                // action_id 기반 매칭 (미완료 상태만)
                let toolBlock: ToolBlock | undefined;
                if (actionId) {
                    toolBlock = msg.blocks.find(
                        b => b.type === 'tool' && (b as any).action_id === actionId && (b as ToolBlock).status !== 'complete'
                    ) as ToolBlock | undefined;
                }
                // fallback: name 기반 매칭
                if (!toolBlock) {
                    toolBlock = [...msg.blocks].reverse().find(
                        b => b.type === 'tool' && (b as ToolBlock).name === d.name && (b as ToolBlock).status !== 'complete'
                    ) as ToolBlock | undefined;
                }

                if (toolBlock) {
                    toolBlock.result = displayResult;
                    toolBlock.status = d.is_error ? 'error' : 'complete';
                    toolBlock.collapsed = d.is_error ? false : true;
                    if (canvasData) toolBlock.canvasData = canvasData;
                    if (canvasTool) toolBlock.canvasTool = canvasTool;
                    if (canvasInfo) toolBlock.canvasInfo = canvasInfo;
                    if (outputFiles) toolBlock.outputFiles = outputFiles;

                    if (canvasData && canvasTool) {
                        this.openCanvas(toolBlock);
                    }
                }
                this.scrollToBottom();
                break;
            }

            // ── PlannerAction: 계획 수립 ──
            case 'plan':
                if (d.phase === 'complete' && d.action_sets) {
                    this.activePlan = (d.action_sets as string[]).map(s => ({ subject: s, status: 'pending' }));
                    this.planExpanded = false;
                    const existing = this._findBlockByActionId(msg, actionId, 'plan')
                        || msg.blocks.find(b => b.type === 'plan') as PlanBlock | undefined;
                    if (existing && existing.type === 'plan') {
                        (existing as PlanBlock).action_sets = d.action_sets;
                        (existing as PlanBlock).mode = d.mode || '';
                        (existing as PlanBlock).analysis = d.analysis || '';
                    } else {
                        msg.blocks.push({
                            type: 'plan',
                            action_id: actionId,
                            action_sets: d.action_sets || [],
                            mode: d.mode || '',
                            analysis: d.analysis || '',
                            collapsed: true,
                        } as PlanBlock);
                    }
                }
                // phase 'generating' → 무시
                this.scrollToBottom();
                break;

            // ── ActionSet 라이프사이클 ──
            case 'action_set_start': {
                const ap = this.activePlan.find(s => s.subject === d.subject);
                if (ap) ap.status = 'running';
                if (d.subject === '최종 응답') break;
                msg.blocks.push({
                    type: 'action_set',
                    action_id: actionId,
                    set_id: event.set_id || '',
                    subject: d.subject || '',
                    title: d.title || '',
                    status: 'running',
                    collapsed: false,
                } as ActionSetBlock);
                this.scrollToBottom();
                break;
            }

            case 'action_set_complete': {
                const ap = this.activePlan.find(s => s.subject === d.subject);
                if (ap) ap.status = d.status || 'completed';
                const asBlock = this._findBlockByActionId(msg, event.set_id, 'action_set')
                    || [...msg.blocks].reverse().find(
                        b => b.type === 'action_set' && (b as ActionSetBlock).subject === d.subject && (b as ActionSetBlock).status === 'running'
                    ) as ActionSetBlock | undefined;
                if (asBlock && asBlock.type === 'action_set') {
                    (asBlock as ActionSetBlock).status = d.status || 'completed';
                    (asBlock as ActionSetBlock).actions_completed = d.actions_completed || 0;
                    if (d.title) (asBlock as ActionSetBlock).title = d.title;
                    (asBlock as ActionSetBlock).collapsed = true;
                }
                if (d.context_stats) this.contextStats = d.context_stats;
                this.scrollToBottom();
                break;
            }

            // ── Canvas 생성/전환 ──
            case 'canvas': {
                // 독립적인 CANVAS 이벤트로 Canvas 열기 (tool_result 경유 없이)
                if (d.canvas_id && d.canvas_type) {
                    // 기존 tool block에서 canvasData 매칭 시도
                    let toolBlock = [...msg.blocks].reverse().find(
                        b => b.type === 'tool' && (b as ToolBlock).canvasData?.canvas_id === d.canvas_id
                    ) as ToolBlock | undefined;

                    if (!toolBlock) {
                        // canvasData를 가진 tool block이 없으면 가상 블록 생성
                        toolBlock = {
                            type: 'tool',
                            action_id: actionId,
                            name: d.canvas_type === 'report' ? 'report_canvas.create' : 'pipeline_canvas.create',
                            input: {},
                            purpose: d.title || '',
                            result: '',
                            status: 'complete',
                            collapsed: true,
                            canvasData: d,
                            canvasTool: d.canvas_type === 'report' ? 'report_canvas.create' : 'pipeline_canvas.create',
                            canvasInfo: d,
                        } as any;
                        msg.blocks.push(toolBlock);
                    }

                    this.openCanvas(toolBlock);

                    // 버퍼링된 canvas_update 재생
                    if (this._pendingCanvasUpdates.length > 0) {
                        setTimeout(() => {
                            this._replayPendingCanvasUpdates();
                        }, 600);
                    }
                }
                break;
            }

            // ── Canvas 실시간 갱신 ──
            case 'canvas_update': {
                // 파이프라인 노드 상태 변경 등을 Canvas iframe에 전달
                if (this.activeCanvas && this.canvasIframe?.nativeElement) {
                    const iframe = this.canvasIframe.nativeElement as HTMLIFrameElement;
                    iframe.contentWindow?.postMessage({
                        type: 'canvas_update',
                        canvas_id: d.canvas_id,
                        updates: d.updates,
                    }, '*');
                } else {
                    // Canvas가 아직 열리지 않았으면 버퍼링
                    this._pendingCanvasUpdates.push({
                        canvas_id: d.canvas_id,
                        updates: d.updates,
                    });
                }
                break;
            }

            // ── OrganizerAction: 컨텍스트 관리 ──
            case 'context_summary': {
                // phase 'start' → 새 블록 생성, 나머지 → 기존 블록 업데이트
                const existing = this._findBlockByActionId(msg, actionId, 'context_summary') as ContextSummaryBlock | undefined;
                if (existing) {
                    existing.phase = d.phase || '';
                    existing.detail = this._formatContextSummaryDetail(d);
                } else {
                    msg.blocks.push({
                        type: 'context_summary',
                        action_id: actionId,
                        phase: d.phase || '',
                        mode: d.mode || '',
                        detail: this._formatContextSummaryDetail(d),
                        collapsed: true,
                    } as ContextSummaryBlock);
                }
                if (d.context_stats) this.contextStats = d.context_stats;
                this.scrollToBottom();
                break;
            }

            case 'instruction_search':
            case 'instruction_update':
                // OrganizerAction 보조 이벤트 — context_summary 블록에 흡수
                break;

            // ── AgentQueue 라이프사이클 ──
            case 'done':
                if (d.context_stats) this.contextStats = d.context_stats;
                this.activePlan = [];
                this.planExpanded = false;
                this.autoCollapseTools();
                this._collapseCurrentTurnWorkBlocks(msg);
                this._collectOutputFiles(msg);
                this._updateChatHistory(msg);
                this.scrollToBottom();
                this.saveConversationLog();
                break;

            case 'error':
                this._appendTextToBlocks(msg, `\n\n**Error:** ${d.message || ''}`);
                break;

            // ── 하위 호환: 이전 세션에서 저장된 이벤트 ──
            case 'text': {
                const blocks = msg.blocks;
                const last = blocks.length > 0 ? blocks[blocks.length - 1] : null;
                let tb: TextBlock;
                if (last && last.type === 'text' && (last as any).action_id === actionId) {
                    tb = last as TextBlock;
                } else {
                    tb = { type: 'text', action_id: actionId, content: '' } as TextBlock;
                    blocks.push(tb);
                }
                tb.content += (d.content || event.content || '');
                this.scrollToBottom();
                break;
            }
        }

        this.cdr.detectChanges();
    }

    // ── action_id 기반 블록 매칭 헬퍼 ──

    private _findBlockByActionId(msg: ChatMessage, actionId: string | undefined, blockType?: string): MessageBlock | null {
        if (!actionId) return null;
        for (const block of msg.blocks) {
            if ((block as any).action_id === actionId) {
                if (!blockType || block.type === blockType) return block;
            }
        }
        return null;
    }

    private _findOrCreateBlock(msg: ChatMessage, actionId: string | undefined, blockType: string, defaults: any): MessageBlock {
        // action_id가 있으면 기존 블록 검색
        if (actionId) {
            const existing = this._findBlockByActionId(msg, actionId, blockType);
            if (existing) return existing;
        }
        // action_id가 없으면 기존 type 기반 fallback (마지막 같은 타입 블록)
        if (!actionId) {
            const blocks = msg.blocks;
            const last = blocks.length > 0 ? blocks[blocks.length - 1] : null;
            if (last && last.type === blockType) return last;
        }
        // 새 블록 생성
        const block = { type: blockType, action_id: actionId, ...defaults };
        msg.blocks.push(block);
        return block;
    }

    private _appendTextToBlocks(msg: ChatMessage, text: string) {
        const blocks = msg.blocks;
        const last = blocks.length > 0 ? blocks[blocks.length - 1] : null;
        if (last && last.type === 'text') {
            (last as TextBlock).content += text;
        } else {
            blocks.push({ type: 'text', content: text });
        }
    }

    private _formatContextSummaryDetail(d: any): string {
        const parts: string[] = [];
        if (d.mode) parts.push(`mode: ${d.mode}`);
        if (d.purpose) parts.push(d.purpose.substring(0, 200));
        if (d.context_size) parts.push(`ctx: ${d.context_size}`);
        if (d.before_size && d.after_size) parts.push(`${d.before_size} → ${d.after_size}`);
        return parts.join(' | ') || d.phase || '';
    }

    public cancelChat() {
        if (this.chatAbortController) {
            this.chatAbortController.abort();
            this.chatAbortController = null;
        }
        this.chatLoading = false;
    }

    public clearChat() {
        this.startNewSession();
    }

    // =========================================================================
    // Tool 접기
    // =========================================================================

    private autoCollapseTools() {
        for (let i = 0; i < this.chatMessages.length - 1; i++) {
            const msg = this.chatMessages[i];
            if (msg.role === 'assistant') {
                for (const block of msg.blocks) {
                    if (block.type === 'tool' || block.type === 'plan' || block.type === 'thinking' || block.type === 'action_set' || block.type === 'context_summary') {
                        block.collapsed = true;
                    }
                }
            }
        }
    }

    private _collapseCurrentTurnWorkBlocks(msg: ChatMessage) {
        for (const block of msg.blocks) {
            if (block.type === 'tool' || block.type === 'plan' || block.type === 'thinking' || block.type === 'action_set' || block.type === 'context_summary') {
                block.collapsed = true;
            }
        }
    }

    private _collectOutputFiles(msg: ChatMessage) {
        const seen = new Set<string>();
        const files: OutputFile[] = [];
        for (const block of msg.blocks) {
            if (block.type === 'tool' && (block as ToolBlock).outputFiles) {
                for (const f of (block as ToolBlock).outputFiles!) {
                    const key = `${f.source}:${f.path}`;
                    if (!seen.has(key)) {
                        seen.add(key);
                        files.push(f);
                    }
                }
            }
        }
        if (files.length > 0) msg.outputFiles = files;
    }

    private _updateChatHistory(assistantMsg: ChatMessage) {
        const idx = this.chatAssistantIdx;
        if (idx > 0) {
            const userMsg = this.chatMessages[idx - 1];
            if (userMsg && userMsg.role === 'user') {
                this.chatHistory.push({ role: 'user', content: userMsg.content });
            }
        }
        const content = this._buildHistoryContent(assistantMsg);
        this.chatHistory.push({ role: 'assistant', content });
    }

    private _buildHistoryContent(msg: ChatMessage): string {
        const parts: string[] = [];
        for (const block of msg.blocks) {
            if (block.type === 'text') {
                const t = (block as TextBlock).content.trim();
                if (t) parts.push(t);
            } else if (block.type === 'tool') {
                const tb = block as ToolBlock;
                if (tb.status === 'complete') {
                    let s = `[Tool: ${tb.name}] ${tb.summary}`;
                    if (tb.result) s += '\nResult: ' + tb.result.substring(0, 500);
                    if (tb.outputFiles && tb.outputFiles.length > 0) {
                        s += '\nOutput files: ' + tb.outputFiles.map(f => f.path).join(', ');
                    }
                    parts.push(s);
                }
            }
        }
        return parts.join('\n\n');
    }

    public getContextUsagePercent(): number {
        if (!this.contextStats) return 0;
        return Math.min(100, Math.round((this.contextStats.total_size / this.contextStats.max_size) * 100));
    }

    public getContextBarColor(): string {
        const pct = this.getContextUsagePercent();
        if (pct >= 90) return 'bg-red-500';
        if (pct >= 70) return 'bg-amber-500';
        return 'bg-blue-500';
    }

    public formatContextSize(size: number): string {
        if (size >= 1000) return (size / 1000).toFixed(1) + 'K';
        return String(size);
    }

    public getContextTypeLabel(type: string): string {
        const labels: Record<string, string> = {
            'user_query': 'User Query',
            'instruction': 'Instruction',
            'system': 'System',
            'action_result': 'Action Result',
            'tool_output': 'Tool Output',
            'summary': 'Summary',
        };
        return labels[type] || type;
    }

    public getContextTypeColor(type: string): string {
        const colors: Record<string, string> = {
            'user_query': 'bg-emerald-500',
            'instruction': 'bg-violet-500',
            'system': 'bg-sky-500',
            'action_result': 'bg-amber-500',
            'tool_output': 'bg-orange-500',
            'summary': 'bg-gray-400',
        };
        return colors[type] || 'bg-gray-300';
    }

    public getContextThresholdPercent(): number {
        if (!this.contextStats) return 0;
        return Math.round((this.contextStats.threshold / this.contextStats.max_size) * 100);
    }

    public getContextTypeEntries(): { type: string, count: number, size: number }[] {
        if (!this.contextStats?.by_type) return [];
        return Object.entries(this.contextStats.by_type).map(([type, v]: [string, any]) => ({
            type, count: v.count, size: v.size,
        })).sort((a, b) => b.size - a.size);
    }

    public toggleToolBlock(block: ToolBlock | ThinkingBlock | PlanBlock | ActionSetBlock | ContextSummaryBlock) {
        block.collapsed = !block.collapsed;
    }

    public getActivePlanSummary(): string {
        const running = this.activePlan.find(s => s.status === 'running');
        if (running) return running.subject;
        const pending = this.activePlan.find(s => s.status === 'pending');
        if (pending) return pending.subject;
        const completed = this.activePlan.filter(s => s.status === 'completed');
        if (completed.length === this.activePlan.length && completed.length > 0) return '모든 단계 완료';
        return this.activePlan[0]?.subject || '';
    }

    public getActivePlanProgress(): string {
        const done = this.activePlan.filter(s => s.status === 'completed').length;
        return `${done}/${this.activePlan.length}`;
    }

    public toggleAllTools(msg: ChatMessage) {
        const toolBlocks = msg.blocks.filter(
            b => b.type === 'tool'
        ) as ToolBlock[];
        if (toolBlocks.length === 0) return;
        const allCollapsed = toolBlocks.every(b => b.collapsed);
        toolBlocks.forEach(b => b.collapsed = !allCollapsed);
    }

    public getToolCount(msg: ChatMessage): number {
        return msg.blocks.filter(b => b.type === 'tool').length;
    }

    // =========================================================================
    // ActionSet 그룹화 (타임라인 렌더링용)
    // =========================================================================

    public getGroupedBlocks(msg: ChatMessage): RenderItem[] {
        const result: RenderItem[] = [];
        let currentGroup: ActionSetGroup | null = null;
        let currentUnit: ThinkingUnit | null = null;
        let unitIndex = 0;

        const flushUnit = () => {
            if (currentUnit && currentGroup) {
                currentGroup.units.push(currentUnit);
                currentUnit = null;
            }
        };

        const flushGroup = () => {
            flushUnit();
            if (currentGroup) {
                result.push(currentGroup);
                currentGroup = null;
                unitIndex = 0;
            }
        };

        for (const block of msg.blocks) {
            if (block.type === 'action_set') {
                flushGroup();
                currentGroup = {
                    type: 'action_set_group',
                    actionSet: block as ActionSetBlock,
                    units: [],
                };
            } else if (block.type === 'text') {
                flushGroup();
                result.push(block);
            } else if (currentGroup) {
                if (block.type === 'thinking') {
                    flushUnit();
                    unitIndex++;
                    currentUnit = { type: 'thinking_unit', index: unitIndex, blocks: [block], collapsed: false };
                } else if (currentUnit) {
                    currentUnit.blocks.push(block);
                } else {
                    unitIndex++;
                    currentUnit = { type: 'thinking_unit', index: unitIndex, blocks: [block], collapsed: false };
                }
            } else {
                result.push(block);
            }
        }

        flushGroup();
        return result;
    }

    public getUnitDecision(unit: any): any {
        return unit.blocks?.find((b: any) => b.type === 'thinking' && b.decision) || null;
    }

    public getUnitToolCount(unit: any): number {
        return unit.blocks?.filter((b: any) => b.type === 'tool').length || 0;
    }

    public trackRenderItem(index: number, item: any): string {
        if (item.type === 'action_set_group') {
            return 'asg_' + (item.actionSet.action_id || item.actionSet.set_id || index);
        }
        return (item.action_id || '') + '_' + item.type + '_' + index;
    }

    public trackUnit(index: number, unit: any): string {
        return 'unit_' + unit.index;
    }

    public toggleActionSetGroup(group: ActionSetGroup) {
        group.actionSet.collapsed = !group.actionSet.collapsed;
    }

    public toggleThinkingUnit(unit: ThinkingUnit) {
        unit.collapsed = !unit.collapsed;
    }

    // =========================================================================
    // Markdown 렌더링
    // =========================================================================

    public renderMarkdown(content: string): string {
        if (!content) return '';
        // /mnt/data/ 경로를 endpoint 파일 서빙 URL로 자동 치환
        let processed = content;
        if (this.currentSessionId) {
            const baseUrl = `/wiz/api/page.agent/endpoint_file?session_id=${this.currentSessionId}&path=`;
            // Markdown 이미지: ![alt](/mnt/data/file.png) → ![alt](endpoint_url)
            processed = processed.replace(/!\[([^\]]*)\]\(\/mnt\/data\/([^)]+)\)/g, `![$1](${baseUrl}$2)`);
            // 일반 경로 참조: /mnt/data/file → endpoint URL (sandbox_url 태그 내부 등)
            processed = processed.replace(/(?<!\()\/mnt\/data\/([^\s"'<>)]+)/g, `${baseUrl}$1`);
        }
        return mdConverter.makeHtml(processed);
    }

    // =========================================================================
    // 스크롤
    // =========================================================================

    public onChatScroll() {
        if (!this.chatContainer?.nativeElement) return;
        const el = this.chatContainer.nativeElement;
        const threshold = 80;
        this.isUserScrolledUp = (el.scrollTop + el.clientHeight) < (el.scrollHeight - threshold);

        // 상단 도달 시 이전 메시지 자동 로딩
        if (el.scrollTop < 100 && this.hasMoreMessages && !this.loadingOlderMessages) {
            this.loadOlderMessages();
        }
    }

    private scrollToBottom() {
        if (this.isUserScrolledUp) return;
        setTimeout(() => {
            if (this.chatContainer && this.chatContainer.nativeElement) {
                const el = this.chatContainer.nativeElement;
                el.scrollTop = el.scrollHeight;
            }
        }, 50);
    }

    // =========================================================================
    // 모델 선택
    // =========================================================================

    public async loadProviders() {
        const { code, data } = await wiz.call('agent_providers');
        if (code === 200) {
            this.providers = data.providers || [];
            this.selectedProvider = data.default_provider || '';
            this.selectedModel = data.default_model || '';
            this.updateCurrentModels();
        }
    }

    public onProviderChange() {
        this.updateCurrentModels();
        if (this.currentModels.length > 0) {
            this.selectedModel = this.currentModels[0].id;
        } else {
            this.selectedModel = '';
        }
    }

    private updateCurrentModels() {
        const prov = this.providers.find(p => p.name === this.selectedProvider);
        this.currentModels = prov ? prov.models : [];
    }

    // =========================================================================
    // Canvas 패널
    // =========================================================================

    public getCanvasUrl(block: ToolBlock): SafeResourceUrl {
        if (!block?.canvasTool) return this.sanitizer.bypassSecurityTrustResourceUrl('');
        const info = block.canvasInfo;
        // group = first segment of tool name (e.g. "pdf" from "pdf.read")
        const toolName = block.canvasTool;
        const group = toolName.includes('.') ? toolName.split('.')[0] : toolName;
        const location = info?.location || 'canvas';
        const cacheKey = `${group}/${location}`;
        if (this.canvasUrls[cacheKey]) return this.canvasUrls[cacheKey];
        const url = `/api/tool-canvas/${encodeURIComponent(group)}/${encodeURIComponent(location)}/index.html`;
        const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.canvasUrls[cacheKey] = safeUrl;
        return safeUrl;
    }

    // =========================================================================
    // Activity Bar + Panel
    // =========================================================================

    public togglePanel(panelId: string) {
        if (panelId === 'chat') {
            this.activePanel = null;
            this.mobileMenuOpen = false;
            return;
        }
        const newPanel = this.activePanel === panelId ? null : panelId;
        this.activePanel = newPanel;
        this.mobileMenuOpen = false;
        if (newPanel === 'storage') {
            this.loadStorageFiles();
        }
        if (newPanel === 'history') {
            this.loadHistory();
        }
        if (newPanel === 'tools') {
            this.loadTools();
        }
        if (newPanel === 'actions') {
            this.loadActions();
        }
        if (newPanel === 'harness') {
            this.loadHarnessSettings();
        }
        if (newPanel === 'settings') {
            this.loadSettings();
        }
        this.cdr.detectChanges();
    }

    public openCanvas(block: ToolBlock, event?: Event) {
        if (event) {
            event.stopPropagation();
        }
        if (!block.canvasData || !block.canvasTool) return;

        // 히스토리에 추가 (동일 블록 중복 방지)
        if (!this.canvasHistory.some(h => h.id === block.id)) {
            this.canvasHistory.push(block);
        }

        this.activeCanvas = block;
        this.canvasRefEnabled = true;
        this.activePanel = 'canvas';
        this.cdr.detectChanges();

        setTimeout(() => {
            this.sendCanvasData(block);
            if (this._pendingCanvasUpdates.length > 0) {
                setTimeout(() => {
                    this._replayPendingCanvasUpdates();
                }, 300);
            }
        }, 500);
    }

    public switchCanvas(block: ToolBlock, event?: Event) {
        if (event) event.stopPropagation();
        this.canvasHistoryDropdownOpen = false;
        this.openCanvas(block);
    }

    public removeCanvasFromHistory(block: ToolBlock, event?: Event) {
        if (event) event.stopPropagation();
        this.canvasHistory = this.canvasHistory.filter(h => h.id !== block.id);
        if (this.activeCanvas?.id === block.id) {
            // 히스토리에 남은 항목이 있으면 마지막 것으로 전환
            if (this.canvasHistory.length > 0) {
                this.openCanvas(this.canvasHistory[this.canvasHistory.length - 1]);
            } else {
                this.activeCanvas = null;
                this.activePanel = null;
            }
        }
        this.cdr.detectChanges();
    }

    public getCanvasLabel(block: ToolBlock): string {
        const fileName = block.canvasData?.file?.name || block.canvasData?.pdf?.file_name || '';
        const toolName = block.canvasTool || '';
        if (fileName) return fileName;
        return block.summary || toolName;
    }

    public getCanvasSource(block: ToolBlock): string {
        // file_ 접두사는 스토리지에서 열린 캔버스
        return block.id?.startsWith('file_') ? 'storage' : 'chat';
    }

    private _replayPendingCanvasUpdates() {
        if (!this.activeCanvas || !this.canvasIframe?.nativeElement) return;
        const iframe = this.canvasIframe.nativeElement as HTMLIFrameElement;
        const pending = this._pendingCanvasUpdates.splice(0);
        for (const update of pending) {
            iframe.contentWindow?.postMessage({
                type: 'canvas_update',
                canvas_id: update.canvas_id,
                updates: update.updates,
            }, '*');
        }
    }

    public closeCanvas() {
        this.activeCanvas = null;
        this.activePanel = null;
        this.canvasHistoryDropdownOpen = false;
        this.cdr.detectChanges();
    }

    public reopenCanvasRef(ref: any) {
        if (!ref?.block) return;
        this.openCanvas(ref.block);
    }

    // ── Canvas 리사이즈 ──

    public startResize(event: MouseEvent) {
        event.preventDefault();
        this.isResizing = true;
        const onMove = (e: MouseEvent) => {
            if (!this.isResizing) return;
            const container = (event.target as HTMLElement).parentElement!;
            const rect = container.getBoundingClientRect();
            const barWidth = 48;
            const availableWidth = rect.width - barWidth;
            let pct = ((e.clientX - rect.left - barWidth) / availableWidth) * 100;
            const chatMinPx = 320;
            const maxPanelPct = ((availableWidth - chatMinPx) / availableWidth) * 100;
            pct = Math.max(20, Math.min(Math.min(75, maxPanelPct), pct));
            this.panelWidth = pct;
            this.cdr.detectChanges();
        };
        const onUp = () => {
            this.isResizing = false;
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
        };
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
    }

    private sendCanvasData(block: ToolBlock) {
        if (!this.canvasIframe?.nativeElement) return;
        const iframe = this.canvasIframe.nativeElement as HTMLIFrameElement;
        iframe.contentWindow?.postMessage({
            type: 'render',
            data: block.canvasData,
        }, '*');
    }

    private setupCanvasListener() {
        window.addEventListener('message', (event) => {
            if (event.data?.type === 'canvas-ready') {
                if (this.activeCanvas) {
                    this.sendCanvasData(this.activeCanvas);
                }
            }
            if (event.data?.type === 'canvas-resize') {
                if (this.activeCanvas) {
                    this.cdr.detectChanges();
                }
            }
            // Canvas에서 컨텍스트 응답 수신
            if (event.data?.type === 'canvas-context') {
                this.canvasContext = event.data.context || null;
                // Promise resolve (requestCanvasContext에서 대기 중)
                if (this._canvasContextResolve) {
                    this._canvasContextResolve(this.canvasContext);
                    this._canvasContextResolve = null;
                }
            }
            // Canvas에서 채팅 액션 요청 수신
            if (event.data?.type === 'canvas-action') {
                const action = event.data;
                if (action.action === 'chat' && action.message) {
                    // Canvas 컨텍스트 저장
                    if (action.context) {
                        this.canvasContext = action.context;
                    }
                    // 채팅 입력란에 메시지 설정 후 전송
                    this.chatInput = action.message;
                    this.cdr.detectChanges();
                    this.sendChat();
                }
            }
        });
    }

    private _canvasContextResolve: ((val: any) => void) | null = null;

    /**
     * Canvas iframe에 get-context 메시지를 보내고 응답을 기다림
     * @returns Canvas 컨텍스트 데이터 또는 null (타임아웃)
     */
    private requestCanvasContext(): Promise<any> {
        return new Promise((resolve) => {
            const iframe = this.canvasIframe?.nativeElement as HTMLIFrameElement;
            if (!iframe?.contentWindow) {
                resolve(null);
                return;
            }
            this._canvasContextResolve = resolve;
            try {
                iframe.contentWindow.postMessage({ type: 'get-context' }, '*');
            } catch (e) {
                console.warn('Canvas context request failed:', e);
                this._canvasContextResolve = null;
                resolve(null);
                return;
            }
            // 500ms 타임아웃
            setTimeout(() => {
                if (this._canvasContextResolve) {
                    this._canvasContextResolve = null;
                    resolve(this.canvasContext); // 기존 컨텍스트 fallback
                }
            }, 500);
        });
    }

    // =========================================================================
    // 키보드 이벤트 (한글 IME 대응)
    // =========================================================================

    public onKeydown(event: KeyboardEvent) {
        if (event.isComposing || this.isComposing) return;

        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.sendChat();
        }
    }

    // =========================================================================
    // 유틸
    // =========================================================================

    public jsonStringify(obj: any): string {
        try {
            return JSON.stringify(obj, null, 2);
        } catch {
            return String(obj);
        }
    }

    public getOutputFileUrl(file: OutputFile): string {
        if (file.source === 'endpoint') {
            return `/wiz/api/${APP_ID}/endpoint_file?session_id=${encodeURIComponent(this.currentSessionId)}&path=${encodeURIComponent(file.path)}`;
        }
        return `/wiz/api/${APP_ID}/storage_file?path=${encodeURIComponent(file.path)}`;
    }

    public downloadOutputFile(file: OutputFile): void {
        if (file.source === 'endpoint') {
            const url = `/wiz/api/${APP_ID}/endpoint_file?session_id=${encodeURIComponent(this.currentSessionId)}&path=${encodeURIComponent(file.path)}`;
            const a = document.createElement('a');
            a.href = url;
            a.download = file.filename;
            a.click();
        } else {
            const url = `/wiz/api/${APP_ID}/storage_download?path=${encodeURIComponent(file.path)}`;
            const a = document.createElement('a');
            a.href = url;
            a.download = file.filename;
            a.click();
        }
    }

    public formatFileSize(bytes: number): string {
        if (!bytes || bytes === 0) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB'];
        let i = 0;
        let s = bytes;
        while (s >= 1024 && i < units.length - 1) { s /= 1024; i++; }
        return i > 0 ? `${s.toFixed(1)} ${units[i]}` : `${Math.round(s)} B`;
    }

    // =========================================================================
    // Tool 요약 생성
    // =========================================================================

    private _generateToolSummary(toolName: string, input: any): string {
        if (!toolName) return '도구 실행';

        const summaryMap: { [key: string]: (input: any) => string } = {
            'read_file': (inp) => `파일 읽기${inp?.path ? ': ' + this._shortenPath(inp.path) : ''}`,
            'write_file': (inp) => `파일 쓰기${inp?.path ? ': ' + this._shortenPath(inp.path) : ''}`,
            'list_files': (inp) => `파일 목록 조회${inp?.path ? ': ' + this._shortenPath(inp.path) : ''}`,
            'list_endpoints': () => '엔드포인트 목록 조회',
            'run_command': (inp) => `명령어 실행${inp?.command ? ': ' + this._truncate(inp.command, 40) : ''}`,
            'web_search': (inp) => `웹 검색${inp?.query ? ': ' + this._truncate(inp.query, 40) : ''}`,
            'search_tools': (inp) => `도구 검색${inp?.keyword ? ': ' + inp.keyword : ''}`,
            'stock_search': (inp) => `종목 검색${inp?.query ? ': ' + inp.query : ''}`,
            'stock_price': (inp) => `주가 조회${inp?.code ? ': ' + inp.code : ''}`,
            'stock_chart': (inp) => `차트 조회${inp?.code ? ': ' + inp.code : ''}`,
            'stock_news': (inp) => `뉴스 조회${inp?.query || inp?.code ? ': ' + (inp.query || inp.code) : ''}`,
            'financial_analysis': (inp) => `재무분석${inp?.code ? ': ' + inp.code : ''}`,
            'create_tool': (inp) => `도구 생성${inp?.name ? ': ' + inp.name : ''}`,
        };

        const generator = summaryMap[toolName];
        if (generator) {
            try {
                return generator(input);
            } catch {
                return toolName;
            }
        }

        const readable = toolName.replace(/_/g, ' ');
        if (input && typeof input === 'object') {
            const mainKey = Object.keys(input).find(k =>
                ['query', 'path', 'name', 'code', 'keyword', 'command', 'url', 'text'].includes(k)
            );
            if (mainKey && input[mainKey]) {
                return `${readable}: ${this._truncate(String(input[mainKey]), 40)}`;
            }
        }
        return readable;
    }

    private _shortenPath(path: string): string {
        if (!path) return '';
        const parts = path.split('/').filter(p => p);
        if (parts.length <= 2) return path;
        return '.../' + parts.slice(-2).join('/');
    }

    private _truncate(text: string, maxLen: number): string {
        if (!text) return '';
        return text.length > maxLen ? text.substring(0, maxLen) + '...' : text;
    }

    // =========================================================================
    // Storage 기능 (User Only)
    // =========================================================================

    public async navigateStorage(path: string) {
        this.storagePath = path;
        this.updateBreadcrumb();
        await this.loadStorageFiles();
    }

    private updateBreadcrumb() {
        const parts = this.storagePath.split('/').filter(p => p);
        this.storageBreadcrumb = [];
        let accumulated = '';
        for (const part of parts) {
            accumulated += '/' + part;
            this.storageBreadcrumb.push({ name: part, path: accumulated });
        }
    }

    public async loadStorageFiles() {
        this.storageLoading = true;
        this.storageFiles = [];
        this.cdr.detectChanges();
        try {
            const { code, data } = await wiz.call('storage_list', {
                path: this.storagePath,
            });
            if (code === 200) {
                this.storageFiles = data.files || [];
                this.storageFiles.sort((a: any, b: any) => {
                    if (a.type === b.type) return a.name.localeCompare(b.name);
                    return a.type === 'dir' ? -1 : 1;
                });
            }
        } catch (e) {
            console.error('Storage load error:', e);
        }
        this.storageLoading = false;
        await this.service.render();
    }

    public onStorageItemClick(item: any) {
        if (item.type === 'dir') {
            const newPath = this.storagePath === '/' ? '/' + item.name : this.storagePath + '/' + item.name;
            this.navigateStorage(newPath);
        } else {
            // 파일 클릭 → 뷰어로 열기
            this.openStorageFile(item);
        }
    }

    public async openStorageFile(item: any) {
        const filePath = (this.storagePath === '/' ? '' : this.storagePath) + '/' + item.name;
        this.storageFileViewer = {
            open: true, loading: true, saving: false,
            filename: item.name, path: filePath,
            content: '', originalContent: '',
            isImage: false, isBinary: false, mimeType: '', size: 0, modified: false,
        };
        this.cdr.detectChanges();

        try {
            const res = await wiz.call('storage_read', { path: filePath });
            if (res.code === 200) {
                if (res.data.is_binary) {
                    this.storageFileViewer.isBinary = true;
                    this.storageFileViewer.filename = res.data.filename;
                    this.storageFileViewer.size = res.data.size;
                    this.storageFileViewer.mimeType = res.data.mime_type || '';
                } else if (res.data.is_image) {
                    this.storageFileViewer.isImage = true;
                    this.storageFileViewer.filename = res.data.filename;
                    this.storageFileViewer.size = res.data.size;
                    this.storageFileViewer.mimeType = res.data.mime_type || '';
                } else {
                    this.storageFileViewer.content = res.data.content || '';
                    this.storageFileViewer.originalContent = res.data.content || '';
                    this.storageFileViewer.filename = res.data.filename;
                    this.storageFileViewer.size = res.data.size;
                    this.storageFileViewer.mimeType = res.data.mime_type || '';
                }
            }
        } catch (e) {
            console.error('File read error:', e);
        }
        this.storageFileViewer.loading = false;
        this.cdr.detectChanges();
    }

    public onStorageFileContentChange(content: string) {
        this.storageFileViewer.content = content;
        this.storageFileViewer.modified = content !== this.storageFileViewer.originalContent;
        this.cdr.detectChanges();
    }

    public async saveStorageFile() {
        if (!this.storageFileViewer.path || this.storageFileViewer.saving) return;
        this.storageFileViewer.saving = true;
        this.cdr.detectChanges();
        try {
            await wiz.call('storage_write', {
                path: this.storageFileViewer.path,
                content: this.storageFileViewer.content,
            });
            this.storageFileViewer.originalContent = this.storageFileViewer.content;
            this.storageFileViewer.modified = false;
        } catch (e) {
            console.error('File save error:', e);
        }
        this.storageFileViewer.saving = false;
        this.cdr.detectChanges();
    }

    public closeStorageFileViewer() {
        this.storageFileViewer.open = false;
        this.cdr.detectChanges();
    }

    public getStorageImageUrl(filePath: string): string {
        return `/wiz/api/${APP_ID}/storage_download?path=${encodeURIComponent(filePath)}`;
    }

    public getFileIcon(filename: string): string {
        const ext = (filename.split('.').pop() || '').toLowerCase();
        const iconMap: { [key: string]: string } = {
            'pdf': '📕', 'doc': '📘', 'docx': '📘', 'xls': '📗', 'xlsx': '📗',
            'ppt': '📙', 'pptx': '📙', 'zip': '📦', 'tar': '📦', 'gz': '📦', 'tgz': '📦',
            'png': '🖼️', 'jpg': '🖼️', 'jpeg': '🖼️', 'gif': '🖼️', 'svg': '🖼️', 'webp': '🖼️',
            'mp4': '🎬', 'mp3': '🎵', 'wav': '🎵',
            'py': '🐍', 'js': '📜', 'ts': '📜', 'json': '📋', 'md': '📝', 'txt': '📝',
            'html': '🌐', 'css': '🎨', 'csv': '📊',
        };
        return iconMap[ext] || '📄';
    }

    public isArchiveFile(filename: string): boolean {
        const ext = (filename.split('.').pop() || '').toLowerCase();
        return ['zip', 'tar', 'gz', 'tgz', 'bz2'].includes(ext) || filename.endsWith('.tar.gz');
    }

    public async createStorageFolder() {
        const name = await this.showPrompt('폴더 생성', '폴더 이름', '');
        if (!name) return;
        try {
            await wiz.call('storage_mkdir', {
                path: (this.storagePath === '/' ? '' : this.storagePath) + '/' + name,
            });
            await this.loadStorageFiles();
        } catch (e) {
            console.error('Mkdir error:', e);
        }
    }

    public async deleteStorageItem(item: any, event: Event) {
        event.stopPropagation();
        if (!(await this.showConfirm(`"${item.name}"을(를) 삭제하시겠습니까?`))) return;
        try {
            const itemPath = (this.storagePath === '/' ? '' : this.storagePath) + '/' + item.name;
            await wiz.call('storage_delete', {
                path: itemPath,
            });
            await this.loadStorageFiles();
        } catch (e) {
            console.error('Delete error:', e);
        }
    }

    public async renameStorageItem(item: any, event: Event) {
        event.stopPropagation();
        const newName = await this.showPrompt('이름 변경', '새 이름', item.name);
        if (!newName || newName === item.name) return;
        try {
            const oldPath = (this.storagePath === '/' ? '' : this.storagePath) + '/' + item.name;
            const newPath = (this.storagePath === '/' ? '' : this.storagePath) + '/' + newName;
            await wiz.call('storage_rename', {
                old_path: oldPath,
                new_path: newPath,
            });
            await this.loadStorageFiles();
        } catch (e) {
            console.error('Rename error:', e);
        }
    }

    public downloadStorageItem(item: any, event: Event) {
        event.stopPropagation();
        const itemPath = (this.storagePath === '/' ? '' : this.storagePath) + '/' + item.name;
        const url = `/wiz/api/${APP_ID}/storage_download?path=${encodeURIComponent(itemPath)}`;
        window.open(url, '_blank');
    }

    // 컨텍스트 메뉴
    public onStorageContextMenu(event: MouseEvent, item: any) {
        event.preventDefault();
        event.stopPropagation();
        this.contextMenu = {
            visible: true,
            x: event.clientX,
            y: event.clientY,
            item: item,
        };
        // 파일이면 연동 가능한 도구 목록 로드
        if (item.type === 'file') {
            this.loadToolsForFile(item.name);
        } else {
            this.storageFileTools = [];
        }
        this.cdr.detectChanges();
    }

    /**
     * 파일 확장자에 매칭되는 Tool 목록 로드
     */
    public async loadToolsForFile(filename: string) {
        this.storageToolsLoading = true;
        this.storageFileTools = [];
        this.cdr.detectChanges();
        try {
            const res = await wiz.call('agent_tools_for_file', { filename });
            if (res.code === 200) {
                this.storageFileTools = res.data?.tools || [];
            }
        } catch (e) {
            this.storageFileTools = [];
        }
        this.storageToolsLoading = false;
        this.cdr.detectChanges();
    }

    /**
     * 스토리지 파일을 Canvas 뷰어로 열기
     * 파일을 세션 endpoint로 복사 후 endpoint 경로로 Canvas 컨텍스트를 설정
     */
    public async openCanvasWithFile(tool: any, item: any) {
        this.closeContextMenu();

        // 파일 경로 구성
        const filePath = (this.storagePath === '/' ? '' : this.storagePath) + '/' + item.name;

        // 스토리지 파일을 세션 endpoint로 복사
        let endpointPath = '';
        let fileUrl = '';
        try {
            const copyRes = await wiz.call("canvas_copy_to_endpoint", {
                session_id: this.currentSessionId,
                storage_path: filePath,
            });
            if (copyRes.code === 200) {
                endpointPath = copyRes.data.endpoint_path;
                const epFilename = copyRes.data.filename;
                fileUrl = `/wiz/api/${APP_ID}/endpoint_file?session_id=${encodeURIComponent(this.currentSessionId)}&path=${encodeURIComponent(epFilename)}`;
            } else {
                // 복사 실패 시 storage_download 폴백
                fileUrl = `/wiz/api/${APP_ID}/storage_download?path=${encodeURIComponent(filePath)}`;
            }
        } catch (e) {
            // 에러 시 storage_download 폴백
            fileUrl = `/wiz/api/${APP_ID}/storage_download?path=${encodeURIComponent(filePath)}`;
        }

        // ToolBlock 형태로 Canvas 활성화
        const canvasBlock: ToolBlock = {
            type: 'tool',
            id: `file_${Date.now()}`,
            name: tool.name,
            summary: `파일 열기: ${item.name}`,
            input: { file_path: filePath },
            status: 'complete',
            result: '',
            collapsed: false,
            canvasData: {
                file: {
                    url: fileUrl,
                    path: filePath,
                    name: item.name,
                },
            },
            canvasTool: tool.name,
            canvasInfo: tool.canvas || null,
        };

        this.canvasContext = {
            tool_name: tool.name,
            file_path: endpointPath || filePath,
        };

        // openCanvas 통합 (히스토리 자동 기록)
        this.openCanvas(canvasBlock);
    }

    public closeContextMenu() {
        this.contextMenu = { visible: false, x: 0, y: 0, item: null };
        this.cdr.detectChanges();
    }

    @HostListener('document:click')
    public onDocumentClick() {
        if (this.contextMenu.visible) {
            this.closeContextMenu();
        }
    }

    @HostListener('document:contextmenu')
    public onDocumentContextMenu() {
        if (this.contextMenu.visible) {
            this.closeContextMenu();
        }
    }

    // =========================================================================
    // History 패널
    // =========================================================================

    public async loadHistory() {
        this.historyLoading = true;
        this.cdr.detectChanges();
        try {
            const res = await wiz.call('conversation_list');
            this.historyList = res.data?.sessions || [];
        } catch (e) {
            this.historyList = [];
        }
        this.historyLoading = false;
        this.cdr.detectChanges();
    }

    public async deleteHistorySession(session: any, event: Event) {
        event.stopPropagation();
        if (!(await this.showConfirm('이 대화 기록을 삭제하시겠습니까?'))) return;
        try {
            await wiz.call('conversation_delete', {
                session_id: session.session_id,
            });
            await this.loadHistory();
        } catch (e) {
            console.error('Delete session error:', e);
        }
    }

    public async restoreHistorySession(session: any, event: Event) {
        event.stopPropagation();
        if (!session) return;

        // 세션 데이터 로드 후 복원 (최근 메시지만)
        this.historyLoading = true;
        this.cdr.detectChanges();
        try {
            const res = await wiz.call('conversation_load', {
                session_id: session.session_id,
                limit: String(this.MESSAGES_PER_PAGE),
            });
            const data = res.data?.session;
            if (data && data.messages && data.messages.length > 0) {
                this.currentSessionId = data.session_id || session.session_id;
                this.restoreSessionData(data);
                this.activePanel = null;
                this.updateUrlSessionId();
            }
        } catch (e) {
            console.error('Restore session error:', e);
        }
        this.historyLoading = false;
        this.cdr.detectChanges();
    }

    public formatTimestamp(ts: string): string {
        if (!ts) return '';
        try {
            const d = new Date(ts);
            return d.toLocaleDateString('ko-KR') + ' ' + d.toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' });
        } catch {
            return ts;
        }
    }

    // =========================================================================
    // Tools 패널
    // =========================================================================

    public async loadTools() {
        this.toolsLoading = true;
        this.toolDetail = null;
        this.toolDetailMode = false;
        this.cdr.detectChanges();
        try {
            const [groupsRes, disabledRes] = await Promise.all([
                wiz.call('agent_tool_groups'),
                wiz.call('agent_disabled_tools'),
            ]);
            this.toolsList = groupsRes.data?.groups || [];
            this.disabledTools = disabledRes.data?.disabled_tools || [];
        } catch (e) {
            this.toolsList = [];
            this.disabledTools = [];
        }
        this.toolsLoading = false;
        this.cdr.detectChanges();
    }

    public get filteredToolsList(): any[] {
        if (!this.toolSearchQuery || !this.toolSearchQuery.trim()) {
            return this.toolsList;
        }
        const q = this.toolSearchQuery.trim().toLowerCase();
        return this.toolsList.filter((group: any) => {
            const title = (group.title || '').toLowerCase();
            const name = (group.name || '').toLowerCase();
            const desc = (group.description || '').toLowerCase();
            if (title.includes(q) || name.includes(q) || desc.includes(q)) return true;
            const tools = group.tools || [];
            return tools.some((t: any) =>
                (t.title || '').toLowerCase().includes(q) ||
                (t.name || '').toLowerCase().includes(q) ||
                (t.description || '').toLowerCase().includes(q) ||
                (t.tags || []).some((tag: string) => tag.toLowerCase().includes(q))
            );
        });
    }

    public get totalToolCount(): number {
        return this.toolsList.reduce((sum: number, g: any) => sum + (g.tool_count || 0), 0);
    }

    public isToolEnabled(toolName: string): boolean {
        return !this.disabledTools.includes(toolName);
    }

    public async toggleTool(toolName: string) {
        const currentlyEnabled = this.isToolEnabled(toolName);
        try {
            const res = await wiz.call('agent_tool_toggle', {
                tool_name: toolName,
                enabled: currentlyEnabled ? 'false' : 'true',
            });
            this.disabledTools = res.data?.disabled_tools || [];
        } catch (e) {
            console.error('Tool toggle error:', e);
        }
        this.cdr.detectChanges();
    }

    public toggleToolExpand(toolName: string) {
        if (this.expandedTools.has(toolName)) {
            this.expandedTools.delete(toolName);
        } else {
            this.expandedTools.add(toolName);
        }
        this.cdr.detectChanges();
    }

    public isToolExpanded(toolName: string): boolean {
        return this.expandedTools.has(toolName);
    }

    public async loadToolDetail(toolName: string) {
        this.toolsLoading = true;
        this.cdr.detectChanges();
        try {
            const res = await wiz.call('agent_tool_detail', { tool_name: toolName });
            this.toolDetail = res.data?.detail || null;
            this.toolDetailMode = true;
            // input_schema에서 기본 테스트 입력 생성
            const schema = this.toolDetail?.input_schema;
            if (schema?.properties) {
                const defaultInput: any = {};
                for (const [key, prop] of Object.entries(schema.properties) as any) {
                    defaultInput[key] = prop.default !== undefined ? prop.default : '';
                }
                this.toolTestInput = JSON.stringify(defaultInput, null, 2);
            } else {
                this.toolTestInput = '{}';
            }
            this.toolTestResult = '';
        } catch (e) {
            this.toolDetail = null;
        }
        this.toolsLoading = false;
        this.cdr.detectChanges();
    }

    public closeToolDetail() {
        this.toolDetail = null;
        this.toolDetailMode = false;
        this.toolTestInput = '{}';
        this.toolTestResult = '';
        this.cdr.detectChanges();
    }

    public async deleteTool() {
        if (!this.toolDetail) return;
        const toolName = this.toolDetail.name;
        const confirmed = await this.showConfirm(`'${toolName}' Tool을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.`);
        if (!confirmed) return;
        try {
            await wiz.call('agent_tool_delete', { tool_name: toolName });
            this.closeToolDetail();
            await this.loadTools();
        } catch (e: any) {
            this.service.alert.show({ title: '오류', message: e.message || '삭제 실패', status: 'error' });
        }
    }

    public async runToolTest() {
        if (!this.toolDetail || this.toolTestRunning) return;
        this.toolTestRunning = true;
        this.toolTestResult = '';
        this.cdr.detectChanges();
        try {
            const res = await wiz.call('agent_tool_test', {
                tool_name: this.toolDetail.name,
                test_input: this.toolTestInput,
            });
            this.toolTestResult = JSON.stringify(res.data?.result, null, 2);
        } catch (e: any) {
            this.toolTestResult = `Error: ${e.message || e}`;
        }
        this.toolTestRunning = false;
        this.cdr.detectChanges();
    }

    public getInputSchemaParams(): any[] {
        if (!this.toolDetail?.input_schema?.properties) return [];
        const props = this.toolDetail.input_schema.properties;
        const required = this.toolDetail.input_schema.required || [];
        return Object.entries(props).map(([key, val]: any) => ({
            name: key,
            type: val.type || '',
            description: val.description || '',
            required: required.includes(key),
        }));
    }

    // =========================================================================
    // Actions 패널
    // =========================================================================

    public async loadActions() {
        this.actionsLoading = true;
        this.actionDetail = null;
        this.actionDetailMode = false;
        this.cdr.detectChanges();
        try {
            const res = await wiz.call('agent_actions');
            this.actionsList = res.data?.actions || [];
        } catch (e) {
            this.actionsList = [];
        }
        this.actionsLoading = false;
        this.cdr.detectChanges();
    }

    public get filteredActionsList(): any[] {
        if (!this.actionSearchQuery || !this.actionSearchQuery.trim()) {
            return this.actionsList;
        }
        const q = this.actionSearchQuery.trim().toLowerCase();
        return this.actionsList.filter((action: any) => {
            const type = (action.type || '').toLowerCase();
            const desc = (action.describe || '').toLowerCase();
            return type.includes(q) || desc.includes(q);
        });
    }

    public toggleActionExpand(actionType: string) {
        if (this.expandedActions.has(actionType)) {
            this.expandedActions.delete(actionType);
        } else {
            this.expandedActions.add(actionType);
        }
        this.cdr.detectChanges();
    }

    public isActionExpanded(actionType: string): boolean {
        return this.expandedActions.has(actionType);
    }

    public async loadActionDetail(actionType: string) {
        this.actionsLoading = true;
        this.cdr.detectChanges();
        try {
            const res = await wiz.call('agent_action_detail', { action_type: actionType });
            this.actionDetail = res.data?.detail || null;
            this.actionDetailMode = true;
        } catch (e) {
            this.actionDetail = null;
        }
        this.actionsLoading = false;
        this.cdr.detectChanges();
    }

    public closeActionDetail() {
        this.actionDetail = null;
        this.actionDetailMode = false;
        this.cdr.detectChanges();
    }

    // =========================================================================
    // Harness 설정 패널
    // =========================================================================

    public async loadHarnessSettings() {
        this.harnessLoading = true;
        this.cdr.detectChanges();
        try {
            const res = await wiz.call('harness_config_load');
            const cfg = res.data?.config || {};
            this.harnessConfig = JSON.parse(JSON.stringify(cfg));
            this.harnessJson = JSON.stringify(cfg, null, 2);
            this.harnessPathInfo = {
                dataRoot: res.data?.data_root || '',
                path: res.data?.path || '',
                relativePath: res.data?.relative_path || 'harness/config.json',
            };
        } catch (e) {
            this.harnessConfig = {};
            this.harnessJson = '{}';
            this.harnessPathInfo = {};
        }
        this.harnessLoading = false;
        this.cdr.detectChanges();
    }

    public async saveHarnessSettings() {
        this.harnessSaving = true;
        this.cdr.detectChanges();
        let configToSave: any;
        if (this.harnessAdvancedMode) {
            try {
                configToSave = JSON.parse(this.harnessJson);
            } catch (e) {
                await this.service.modal.error('Harness JSON 형식이 올바르지 않습니다.');
                this.harnessSaving = false;
                this.cdr.detectChanges();
                return;
            }
        } else {
            configToSave = JSON.parse(JSON.stringify(this.harnessConfig));
        }

        try {
            const res = await wiz.call('harness_config_save', { config: JSON.stringify(configToSave) });
            const savedConfig = res.data?.config || configToSave;
            this.harnessConfig = JSON.parse(JSON.stringify(savedConfig));
            this.harnessJson = JSON.stringify(savedConfig, null, 2);
            this.harnessPathInfo = {
                dataRoot: res.data?.data_root || this.harnessPathInfo?.dataRoot || '',
                path: res.data?.path || this.harnessPathInfo?.path || '',
                relativePath: res.data?.relative_path || this.harnessPathInfo?.relativePath || 'harness/config.json',
            };
            await this.service.modal.success('Harness 설정이 저장되었습니다.');
        } catch (e) {
            await this.service.modal.error('Harness 설정 저장에 실패했습니다.');
        }
        this.harnessSaving = false;
        this.cdr.detectChanges();
    }

    public toggleHarnessMode() {
        if (this.harnessAdvancedMode) {
            try {
                this.harnessConfig = JSON.parse(this.harnessJson);
            } catch (e) { /* 유지 */ }
        } else {
            this.harnessJson = JSON.stringify(this.harnessConfig, null, 2);
        }
        this.harnessAdvancedMode = !this.harnessAdvancedMode;
        this.cdr.detectChanges();
    }

    public updateHarnessValue(path: string, value: any) {
        const keys = path.split('.');
        let obj = this.harnessConfig;
        for (let i = 0; i < keys.length - 1; i++) {
            if (!obj[keys[i]] || typeof obj[keys[i]] !== 'object') obj[keys[i]] = {};
            obj = obj[keys[i]];
        }
        obj[keys[keys.length - 1]] = value;
    }

    public getHarnessValue(path: string, defaultVal: any = ''): any {
        const keys = path.split('.');
        let obj = this.harnessConfig;
        for (const k of keys) {
            if (obj && typeof obj === 'object' && k in obj) {
                obj = obj[k];
            } else {
                return defaultVal;
            }
        }
        return obj;
    }

    public getHarnessModeLabel(): string {
        const mode = this.getHarnessValue('permissions.mode', 'advisory');
        if (mode === 'enforce') return 'Enforce';
        if (mode === 'off') return 'Off';
        return 'Advisory';
    }

    // =========================================================================
    // Settings 패널 (agent.json)
    // =========================================================================

    public async loadSettings() {
        this.settingsLoading = true;
        this.cdr.detectChanges();
        try {
            const res = await wiz.call('config_load');
            const cfg = res.data?.config || {};
            this.settingsConfig = JSON.parse(JSON.stringify(cfg));
            this.settingsJson = JSON.stringify(cfg, null, 2);
        } catch (e) {
            this.settingsConfig = {};
            this.settingsJson = '{}';
        }
        this.refreshSettingsCache();
        this.settingsLoading = false;
        this.cdr.detectChanges();
    }

    public async saveSettings() {
        this.settingsSaving = true;
        this.cdr.detectChanges();
        let configToSave: any;
        if (this.settingsAdvancedMode) {
            try {
                configToSave = JSON.parse(this.settingsJson);
            } catch (e) {
                await this.service.modal.error('JSON 형식이 올바르지 않습니다.');
                this.settingsSaving = false;
                this.cdr.detectChanges();
                return;
            }
        } else {
            configToSave = JSON.parse(JSON.stringify(this.settingsConfig));
        }
        try {
            await wiz.call('config_save', { config: JSON.stringify(configToSave) });
            this.settingsConfig = configToSave;
            this.settingsJson = JSON.stringify(configToSave, null, 2);
            this.refreshSettingsCache();
            await this.service.modal.success('설정이 저장되었습니다.');
        } catch (e) {
            await this.service.modal.error('설정 저장에 실패했습니다.');
        }
        this.settingsSaving = false;
        this.cdr.detectChanges();
    }

    public toggleSettingsMode() {
        if (this.settingsAdvancedMode) {
            // JSON → 구조화: JSON 파싱 후 config 반영
            try {
                this.settingsConfig = JSON.parse(this.settingsJson);
            } catch (e) { /* 유지 */ }
            this.refreshSettingsCache();
        } else {
            // 구조화 → JSON: config를 JSON 문자열로 반영
            this.settingsJson = JSON.stringify(this.settingsConfig, null, 2);
        }
        this.settingsAdvancedMode = !this.settingsAdvancedMode;
        this.cdr.detectChanges();
    }

    public refreshSettingsCache() {
        this.settingsProviderList = Object.keys(this.settingsConfig?.llm?.providers || {});
        this.settingsProviderModelsMap = {};
        for (const p of this.settingsProviderList) {
            this.settingsProviderModelsMap[p] = this.getProviderModels(p);
        }
    }

    public getProviderNames(): string[] {
        return Object.keys(this.settingsConfig?.llm?.providers || {});
    }

    public getProviderModels(providerName: string): any[] {
        const models = this.settingsConfig?.llm?.providers?.[providerName]?.models || {};
        return Object.entries(models).map(([id, conf]: any) => ({
            id,
            model_id: conf.model_id || id,
            description: conf.description || '',
            context_length: conf.context_length || 0,
            max_output_tokens: conf.max_output_tokens || 0,
        }));
    }

    public updateConfigValue(path: string, value: any) {
        const keys = path.split('.');
        let obj = this.settingsConfig;
        for (let i = 0; i < keys.length - 1; i++) {
            if (!obj[keys[i]]) obj[keys[i]] = {};
            obj = obj[keys[i]];
        }
        obj[keys[keys.length - 1]] = value;
    }

    public getConfigValue(path: string, defaultVal: any = ''): any {
        const keys = path.split('.');
        let obj = this.settingsConfig;
        for (const k of keys) {
            if (obj && typeof obj === 'object' && k in obj) {
                obj = obj[k];
            } else {
                return defaultVal;
            }
        }
        return obj;
    }

    public addProvider() {
        const name = prompt('프로바이더 이름을 입력하세요:');
        if (!name || !name.trim()) return;
        const key = name.trim();
        if (!this.settingsConfig.llm) this.settingsConfig.llm = {};
        if (!this.settingsConfig.llm.providers) this.settingsConfig.llm.providers = {};
        if (this.settingsConfig.llm.providers[key]) {
            alert('이미 존재하는 프로바이더입니다.');
            return;
        }
        this.settingsConfig.llm.providers[key] = { api_key: '', base_url: '', models: {} };
        this.refreshSettingsCache();
        this.cdr.detectChanges();
    }

    public removeProvider(name: string) {
        if (!confirm(`프로바이더 "${name}"을(를) 삭제하시겠습니까?`)) return;
        if (this.settingsConfig?.llm?.providers?.[name]) {
            delete this.settingsConfig.llm.providers[name];
            this.refreshSettingsCache();
            this.cdr.detectChanges();
        }
    }

    public addModelToProvider(provider: string) {
        const id = prompt('모델 ID를 입력하세요:');
        if (!id || !id.trim()) return;
        const key = id.trim();
        const models = this.settingsConfig?.llm?.providers?.[provider]?.models;
        if (!models) return;
        if (models[key]) {
            alert('이미 존재하는 모델입니다.');
            return;
        }
        models[key] = { model_id: key, description: '', context_length: 128000, max_output_tokens: 8192 };
        this.refreshSettingsCache();
        this.cdr.detectChanges();
    }

    public removeModelFromProvider(provider: string, modelId: string) {
        if (!confirm(`모델 "${modelId}"을(를) 삭제하시겠습니까?`)) return;
        const models = this.settingsConfig?.llm?.providers?.[provider]?.models;
        if (models && models[modelId]) {
            delete models[modelId];
            this.refreshSettingsCache();
            this.cdr.detectChanges();
        }
    }

    public triggerFileUpload() {
        if (this.storageFileInput?.nativeElement) {
            this.storageFileInput.nativeElement.click();
        }
    }

    public async onStorageFileSelected(event: any) {
        const files = event.target?.files;
        if (!files || files.length === 0) return;
        await this.uploadFiles(files);
        if (this.storageFileInput?.nativeElement) {
            this.storageFileInput.nativeElement.value = '';
        }
    }

    // 드래그 앤 드롭 (외부 파일 업로드)
    public onStorageDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        // 내부 파일 이동 중이면 외부 드래그 오버레이 표시 안 함
        if (this.storageDragItem) return;
        this.isDraggingOver = true;
    }

    public onStorageDragLeave(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isDraggingOver = false;
    }

    public async onStorageDrop(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isDraggingOver = false;
        // 내부 파일 이동 중이면 무시 (onItemDrop에서 처리)
        if (this.storageDragItem) return;
        const files = event.dataTransfer?.files;
        if (!files || files.length === 0) return;
        await this.uploadFiles(files);
    }

    // 드래그 앤 드롭 (내부 파일/폴더 이동)
    public onItemDragStart(event: DragEvent, item: any) {
        this.storageDragItem = item;
        event.dataTransfer!.effectAllowed = 'move';
        event.dataTransfer!.setData('text/plain', item.name);
    }

    public onItemDragEnd(event: DragEvent) {
        this.storageDragItem = null;
        this.storageDragOverFolder = null;
        this.cdr.detectChanges();
    }

    public onItemDragOver(event: DragEvent, targetItem: any) {
        if (!this.storageDragItem) return;
        if (targetItem.type !== 'dir') return;
        if (targetItem.name === this.storageDragItem.name) return;
        event.preventDefault();
        event.stopPropagation();
        event.dataTransfer!.dropEffect = 'move';
        this.storageDragOverFolder = targetItem.name;
        this.cdr.detectChanges();
    }

    public onItemDragLeave(event: DragEvent) {
        this.storageDragOverFolder = null;
        this.cdr.detectChanges();
    }

    public async onItemDrop(event: DragEvent, targetItem: any) {
        event.preventDefault();
        event.stopPropagation();
        const dragItem = this.storageDragItem;
        this.storageDragItem = null;
        this.storageDragOverFolder = null;

        if (!dragItem || targetItem.type !== 'dir' || dragItem.name === targetItem.name) return;

        const srcPath = (this.storagePath === '/' ? '' : this.storagePath) + '/' + dragItem.name;
        const destPath = (this.storagePath === '/' ? '' : this.storagePath) + '/' + targetItem.name + '/' + dragItem.name;

        try {
            await wiz.call('storage_move', {
                source_path: srcPath,
                target_path: destPath,
            });
            await this.loadStorageFiles();
        } catch (e) {
            console.error('Move error:', e);
        }
    }

    // 압축 풀기 / 압축하기
    public async storageUnzipFile(item: any) {
        if (!item || item.type !== 'file') return;
        const filePath = (this.storagePath === '/' ? '' : this.storagePath) + '/' + item.name;
        this.storageLoading = true;
        this.cdr.detectChanges();
        try {
            await wiz.call('storage_unzip', { path: filePath });
        } catch (e) {
            console.error('Unzip error:', e);
        }
        await this.loadStorageFiles();
    }

    public async storageZipItem(item: any) {
        if (!item) return;
        const itemPath = (this.storagePath === '/' ? '' : this.storagePath) + '/' + item.name;
        this.storageLoading = true;
        this.cdr.detectChanges();
        try {
            await wiz.call('storage_zip', { path: itemPath });
        } catch (e) {
            console.error('Zip error:', e);
        }
        await this.loadStorageFiles();
    }

    private async uploadFiles(files: FileList) {
        this.uploadProgress = [];
        for (let i = 0; i < files.length; i++) {
            this.uploadProgress.push({ name: files[i].name, percent: 0 });
        }
        this.cdr.detectChanges();

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            try {
                const formData = new FormData();
                formData.append('file', file);
                formData.append('path', this.storagePath);

                const xhr = new XMLHttpRequest();
                xhr.upload.onprogress = (e) => {
                    if (e.lengthComputable && this.uploadProgress[i]) {
                        this.uploadProgress[i].percent = Math.round((e.loaded / e.total) * 100);
                        this.cdr.detectChanges();
                    }
                };

                await new Promise<void>((resolve, reject) => {
                    xhr.onload = () => {
                        if (xhr.status >= 200 && xhr.status < 300) {
                            resolve();
                        } else {
                            console.error('Upload failed:', xhr.status, xhr.responseText);
                            reject(new Error(`Upload failed: ${xhr.status}`));
                        }
                    };
                    xhr.onerror = () => reject(new Error('Upload network error'));
                    xhr.open('POST', `/wiz/api/${APP_ID}/storage_upload`);
                    xhr.send(formData);
                });
            } catch (e) {
                console.error('Upload error:', e);
            }
        }

        this.uploadProgress = [];
        await this.loadStorageFiles();
    }

    // =========================================================================
    // 대화 로그 저장
    // =========================================================================

    private async saveConversationLog() {
        if (!this.currentSessionId || this.chatMessages.length === 0) return;
        try {
            const logMessages = this.chatMessages.map(m => ({
                role: m.role,
                content: m.content || '',
                blocks: m.blocks.map(b => this.serializeBlock(b)),
            }));
            await wiz.call('conversation_save', {
                session_id: this.currentSessionId,
                messages: JSON.stringify(logMessages),
            });
        } catch (e) {
            console.error('Conversation log save error:', e);
        }
    }

    private serializeBlock(b: MessageBlock): any {
        switch (b.type) {
            case 'text':
                return { type: 'text', content: (b as TextBlock).content };
            case 'tool': {
                const t = b as ToolBlock;
                return { type: 'tool', id: t.id, name: t.name, summary: t.summary, input: t.input, status: t.status, result: t.result || '', canvasData: t.canvasData || null, canvasTool: t.canvasTool || null, outputFiles: t.outputFiles || undefined };
            }
            case 'thinking': {
                const th = b as ThinkingBlock;
                return { type: 'thinking', content: th.content, collapsed: th.collapsed, status: th.status, decision: th.decision, analysis: th.analysis, reasoning: th.reasoning, action_count: th.action_count };
            }
            case 'plan': {
                const p = b as PlanBlock;
                return { type: 'plan', action_sets: p.action_sets, mode: p.mode, analysis: p.analysis };
            }
            case 'action_set': {
                const as_ = b as ActionSetBlock;
                return { type: 'action_set', set_id: as_.set_id || '', subject: as_.subject, title: as_.title || '', status: as_.status, actions_completed: as_.actions_completed || 0 };
            }
            case 'context_summary': {
                const cs = b as ContextSummaryBlock;
                return { type: 'context_summary', phase: cs.phase, mode: cs.mode, detail: cs.detail };
            }
            default:
                return { type: b.type };
        }
    }
}

export default PageAgentComponent;